// extracted by mini-css-extract-plugin
export default {"actionContainer":"usersPage_actionContainer__XP0pZ","contentContainer":"usersPage_contentContainer__AN3Hp","dataGridContainer":"usersPage_dataGridContainer__RpBL3"};